import { render, staticRenderFns } from "./PromoPage.vue?vue&type=template&id=bedf6476&scoped=true&"
import script from "./PromoPage.vue?vue&type=script&lang=js&"
export * from "./PromoPage.vue?vue&type=script&lang=js&"
import style0 from "./PromoPage.vue?vue&type=style&index=0&id=bedf6476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf6476",
  null
  
)

export default component.exports